import type { FetchOptions } from '@atlassian/jira-insights-common-constants/src/common/types/fetch.tsx';

export type GetSelectFieldStatisticsParams = {
	customFieldId: string;
	query: string;
	limit: number;
	fetchOptions?: FetchOptions;
};

export type SelectFieldStatisticsResponse = {
	slices: Record<string, number>;
	other: number;
	emptyValues: number;
};

export type GetNumericFieldStatisticsParams = {
	customFieldId: string;
	query: string;
	fetchOptions?: FetchOptions;
};

export type NumericStats = {
	min: number | null;
	max: number | null;
	sum: number | null;
	count: number;
};

export type NonNullableDataType = {
	label: string;
	value: number;
};

export type DataType = { label: string; value: number | null };

export type SingleSelectChartType =
	| 'DONUT_CHART'
	| 'BAR_CHART'
	| 'HORIZONTAL_BAR_CHART'
	| 'PIE_CHART'
	| 'LINE_CHART';

export const SingleSelectChartTypes: SingleSelectChartType[] = [
	'BAR_CHART',
	'HORIZONTAL_BAR_CHART',
	'LINE_CHART',
	'PIE_CHART',
	'DONUT_CHART',
];
